/*
 * The page root carries the theme. Menus, dialogs, tooltips and toasts open in portals on
 * <body>, outside the app's tree, and get the theme from there. Panels that pin themselves dark
 * (the video surfaces) keep their own theme.
 */

import type { Unsubscribe } from '@/types/common';
import { Theme } from '@/types/panels';

const THEME_CLASS = 'theme-occurra';
export const DARK_CLASS = 'dark';

function showThemeColor(theme: Theme): void {
    for (const meta of document.querySelectorAll<HTMLMetaElement>('meta[name="theme-color"]')) {
        meta.media = meta.dataset.theme === theme ? 'all' : 'not all';
    }
}

export function showThemeOnPage(theme: Theme): () => void {
    const root = document.documentElement;
    root.classList.add(THEME_CLASS);
    root.classList.toggle(DARK_CLASS, theme === Theme.Dark);
    showThemeColor(theme);
    return (): void => root.classList.remove(THEME_CLASS, DARK_CLASS);
}

/** The theme on the page root, for the toaster, which renders outside the store. */
export function getPageTheme(): Theme {
    return document.documentElement.classList.contains(DARK_CLASS) ? Theme.Dark : Theme.Light;
}

export function subscribeToPageTheme(listener: () => void): Unsubscribe {
    const observer = new MutationObserver(listener);
    observer.observe(document.documentElement, { attributeFilter: ['class'] });
    return (): void => observer.disconnect();
}
